// extracted by mini-css-extract-plugin
export default {"doorway-form-layout":"styles_doorway-form-layout__tXvth","doorway-form-container":"styles_doorway-form-container__9-dir","doorway-form-title":"styles_doorway-form-title__GlqqX"};